module.exports = __webpack_public_path__ + "img/American_Credit_Equipment_Financing_Customer_Vioce.b32eae7.png";